/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus': {
    width: 533.333,
    height: 533.333,
    viewBox: '0 0 533.333 533.333',
    data: '<path pid="0" d="M516.667 200H333.333V16.667C333.333 7.462 325.871 0 316.667 0h-100C207.462 0 200 7.462 200 16.667V200H16.667C7.462 200 0 207.462 0 216.667v100c0 9.204 7.462 16.666 16.667 16.666H200v183.334c0 9.204 7.462 16.666 16.667 16.666h100c9.204 0 16.667-7.462 16.667-16.666V333.333h183.333c9.204 0 16.667-7.462 16.667-16.666v-100c-.001-9.205-7.463-16.667-16.667-16.667z"/>'
  }
})
